const translations: Record<string, string> = {
  "ak_dsp2_actual_pv_bess_discharge_saved_h_for": "Факт (PV + розряд УЗЕ) збережено ({{n}} год) для {{d}}.",
  "ak_dsp2_actual_generation_saved_h_for": "Фактичну генерацію збережено ({{n}} год) для {{d}}.",
  "ak_dsp2_mms_schedule_saved_version_entry_added": "Графік до MMS збережено (версія {{rev}}) — запис додано до «Збережені графіки». Ваша СЕС: {{own}} кВт·год, група: {{grp}} кВт·год",
  "ak_dsp2_error": "помилка",
  "ak_dsp2_mms_schedule_ver": "графік MMS: вер. {{r}}",
  "ak_dsp2_editing_actuals_pv_generation_bess_dis": "Редагується факт: Генерація PV + Розряд УЗЕ",
  "ak_dsp2_editing_the_actual_row": "Редагується рядок «Факт»",
  "ak_dsp2_editing_the_uploaded_to_mms_row_versio": "Редагується рядок «Завантажено на MMS» (версія {{rev}})",
  "ak_dsp2_hours_changed": "змінено годин: {{n}}",
  "ak_dsp2_manually_adjusted_model_kwh": "Скориговано вручну{{by}}. Модель: {{m}} кВт·год",
  "ak_dsp2_the_schedule_for_this_day_can_no_longe": "Графік на цю добу вже не редагується: дедлайн версії {{rev}} минув. ",
  "ak_dsp2_a_schedule_can_only_be_submitted_for_a": "Подати графік можна лише на добу, дедлайн якої ще не настав — оберіть",
  "ak_dsp2_or_a_later_date": " або пізнішу дату.",
  "ak_dsp2_forecast_values_are_pre_filled_edit_on": "Підставлено значення прогнозу — правте лише ті години, що відрізняються. Зберігається внесок саме цієї СЕС; груповий підсумок X-коду перерахується автоматично, за учасників групи, яких ще не правили, підставиться їхній прогноз. Раніше сформований XML буде анульовано — після правок сформуйте його наново.",
  "ak_dsp2_no_changes_to_save": "Немає змін для збереження.",
  "ak_dsp2_failed_to_save": "Не вдалося зберегти",
  "ak_dsp2_generation_forecast_kwh": "Прогноз генерації, кВт·год",
  "ak_dsp2_actual_generation_kwh": "Факт генерації, кВт·год",
  "ak_dsp2_uploaded_to_mms_kwh": "Завантажено на MMS, кВт·год",
  "ak_dsp2_bess_charge_discharge_kwh": "Заряд / Розряд УЗЕ, кВт·год",
  "ak_dsp2_dam_price_uah_mwh": "Ціна РДН, грн/МВт·год",
  "ak_dsp2_actual_pv_generation_kwh": "Факт: Генерація PV, кВт·год",
  "ak_dsp2_actual_bess_discharge_kwh": "Факт: Розряд УЗЕ, кВт·год",
  "ak_dsp2_hourly_data": "Погодинні дані",
  "ak_dsp2_preparing": "Готуємо…",
  "ak_dsp2_edit_actuals_enter_actual_generation_m": "Редагування факту — внести фактичну генерацію вручну (СЕС Лучки, з 01.09.2026)",
  "ak_dsp2_edit_actuals_enter_manually_pv_generat": "Редагування факту — внести вручну: Генерація PV + Розряд УЗЕ (СЕС Табаки, минулі дати)",
  "ak_dsp2_no_active_schedule_version": "Немає активної версії графіка",
  "ak_dsp2_version_deadline_has_passed_the_schedu": "Дедлайн версії минув — графік не редагується",
  "ak_dsp2_edit_forecast_edit_the_uploaded_to_mms": "Редагування прогнозу — правити рядок «Завантажено на MMS» (підставлено прогноз)",
  "ak_dsp2_cancel": "Відмінити",
  "ak_dsp2_saving": "Збереження…",
  "ak_dsp2_save": "Зберегти",
  "ak_dsp2_loading": "Завантаження…",
  "ak_dsp2_no_data_for_this_day": "Немає даних за цю добу",
  "ak_dsp2_hour": "Година",
  "ak_dsp2_value_taken_from_the_forecast_the_sche": "Значення з прогнозу — графік ще не збережено",
  "ak_dsp2_editing_is_available_to_the_operator_a": "Редагування доступне ролям «Оператор» і «CTO».",
  "ak_dsp2_the_schedule_for_this_day_cannot_be_ed": "Графік на цю добу не редагується: усі версії закрито. ",
  "ak_dsp2_kwh": "кВт·год",
  "ak_dsp2_w_m": "Вт/м²",
  "ak_dsp2_forecast_adjusted_manually_model_gave": "прогноз скориговано вручну · модель давала {{m}}",
  "ak_dsp2_generation_forecast": "Прогноз генерації",
  "ak_dsp2_actual_generation": "Факт вироблення",
  "ak_dsp2_to_grid": "  · у мережу",
  "ak_dsp2_to_bess_charge": "  · у заряд УЗЕ",
  "ak_dsp2_auxiliary_use_imbalance": "  · власні потреби / небаланс",
  "ak_dsp2_bess_discharge_to_grid": "Розряд УЗЕ в мережу",
  "ak_dsp2_bess_soc_hourly_avg": "SOC УЗЕ (сер. за год.)",
  "ak_dsp2_overperformance": "Перевиконання",
  "ak_dsp2_shortfall": "Недобір",
  "ak_dsp2_uploaded_to_mms": "Завантажено на MMS",
  "ak_dsp2_cloud_cover": "Хмарність",
  "ak_dsp2_solar_radiation": "Сонячна радіація",
  "ak_dsp2_forecast_kwh": "Прогноз, кВт·год",
  "ak_dsp2_actual_kwh": "Факт, кВт·год",
  "ak_dsp2_bess_charge": "Заряд УЗЕ",
  "ak_dsp2_bess_discharge": "Розряд УЗЕ",
  "ak_dsp2_bess_soc": "SOC УЗЕ, %",
  "ak_dsp2_bess_soc_2": "SOC УЗЕ",
  "ak_dsp2_hourly_forecast_vs_actual_vs_mms": "Погодинний прогноз vs факт vs MMS",
  "ak_dsp2_generation_output_kwh": "Вироблення · віддача, кВт·год",
  "ak_dsp2_no_mms_schedule_was_saved_for_this_day": "графік до MMS на цю добу не зберігався",
};

export default translations;
